import { grey, red, blue } from '../../../styles/colours';
export var InputContainerStylePropertiesByVariant = {
    default: function (theme) {
        var _a, _b, _c, _d, _e, _f, _g;
        return ({
            borderColor: (_a = theme.borderSecondary) !== null && _a !== void 0 ? _a : grey[500],
            backgroundColor: (_b = theme.backgroundUI) !== null && _b !== void 0 ? _b : grey[0],
            errorBorderColor: (_c = theme.borderNegative) !== null && _c !== void 0 ? _c : red[800],
            hoverBackgroundColor: (_d = theme.backgroundSecondary) !== null && _d !== void 0 ? _d : grey[50],
            focusWithinBorderColor: (_e = theme.borderAccent) !== null && _e !== void 0 ? _e : blue[500],
            focusWithinErrorBorderColor: (_f = theme.borderNegative) !== null && _f !== void 0 ? _f : red[800],
            errorColor: (_g = theme.contentNegative) !== null && _g !== void 0 ? _g : red[800],
        });
    },
};
//# sourceMappingURL=InputContainerStylePropertiesByVariant.js.map